import { motion } from "framer-motion";
import { useLanguage } from "../../hooks/useLanguage";
import React from "react";

export default function Hero() {
  const { t } = useLanguage();

  return (
    <div className="relative bg-gradient-to-r from-primary/90 to-secondary/90 h-screen max-h-[700px]">
      <div className="absolute inset-0">
        <motion.img
          initial={{ scale: 1.1, opacity: 0 }}
          animate={{ scale: 1, opacity: 0.3 }}
          transition={{ duration: 1.5 }}
          src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
          alt="Restaurant interior"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex flex-col justify-center h-full">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="text-5xl md:text-7xl font-bold text-white mb-6 drop-shadow-lg"
          >
            {t("hero.title")}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            className="text-xl text-white/95 mb-8 max-w-2xl drop-shadow-md"
          >
            {t("hero.subtitle")}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
            className="flex flex-wrap gap-4"
          >
            <a
              href="#book"
              className="bg-white text-primary px-8 py-3 rounded-full font-semibold hover:bg-primary hover:text-white transition-colors duration-300 shadow-lg transform hover:scale-105"
            >
              {t("hero.bookTable")}
            </a>
            <a
              href="#menu"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white/20 transition-colors shadow-lg transform hover:scale-105"
            >
              {t("hero.viewMenu")}
            </a>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
